import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

/**
 * Shown when a user is authenticated with Firebase Auth but has no usable
 * Florra profile (missing users/{uid} doc, or no companyId). Without this the
 * app would bounce between RoleRedirect and the login page forever. The only
 * action is to sign out — an admin must (re)create the profile.
 */
export default function AccessErrorScreen() {
  const { t } = useTranslation();
  const { logout } = useAuth();

  return (
    <div className="login-page">
      <div className="login-card" style={{ textAlign: 'center' }}>
        <h1 className="login-title">{t('auth.accessErrorTitle')}</h1>
        <p className="login-subtitle" style={{ marginBottom: 24 }}>
          {t('auth.accessErrorBody')}
        </p>
        <button className="btn btn-primary btn-lg btn-block" onClick={logout}>
          {t('auth.signOut')}
        </button>
      </div>
    </div>
  );
}
